
export function oneOf() {
    for (let i = 0; i < arguments.length; i++) {
        if (arguments[i] != null && arguments[i] !== '' && arguments[i] !== 0) return arguments[i];
    }
    return arguments[arguments.length];
};
